<div aria-hidden="true" role="status" class="container py-16">
	@if (header()) {
		<div
			class="hidden space-y-8 animate-pulse sm:space-y-0 sm:space-x-8 sm:flex sm:items-center"
			[ngClass]="{ 'border-b border-gray-200 pb-16': banner() }"
		>
			<div
				class="flex items-center justify-center w-20 h-20 bg-gray-300 rounded-full dark:bg-gray-500"
			>
				<uc-loading-image-svg customStyles="w-10 h-10" />
			</div>
			<div class="w-full">
				<div
					class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-500 w-48 mb-4"
				></div>
				<div
					class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 max-w-[480px] mb-2.5"
				></div>
				<div
					class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 mb-2.5 w-10/12"
				></div>
			</div>
		</div>
	}
	@if (banner()) {
		<div class="md:py-16">
			<div
				class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center"
			>
				<div
					class="flex items-center justify-center w-full bg-gray-300 rounded h-72 dark:bg-gray-500"
				>
					<uc-loading-image-svg />
				</div>
				<div class="flex flex-col justify-between w-full p-8 h-72">
					<div class="w-full h-full">
						<div
							class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-500 w-48 mb-4"
						></div>
						<div
							class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 max-w-[480px] mb-2.5"
						></div>
						<div
							class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 mb-2.5"
						></div>
						<div
							class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 max-w-[440px] mb-2.5"
						></div>
						<div
							class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 max-w-[460px] mb-2.5"
						></div>
						<div
							class="h-3 bg-gray-200 rounded-full dark:bg-gray-500 max-w-[360px]"
						></div>
					</div>
					<div
						class="w-full h-10 bg-gray-200 rounded-lg dark:bg-gray-500 sm:mx-auto"
					></div>
				</div>
				<span class="sr-only">Loading...</span>
			</div>
		</div>
	}
</div>
